import { motion } from 'framer-motion';
import { getCoordinates, getLowestAvailableRow } from './logic';
import './Connect4.css';

const ROWS = 6;
const COLS = 7;

const Connect4Board = ({ board, onColumnClick, winningCombination, disabled }) => {
  // Safety check for board
  if (!board || !Array.isArray(board)) {
    console.error('Connect4Board: Invalid board provided:', board);
    return (
      <div className="connect4-board">
        <div style={{ color: 'white', padding: '2rem' }}>
          Loading board...
        </div>
      </div>
    );
  }

  const isWinningCell = (index) => {
    return winningCombination && winningCombination.includes(index);
  };

  const isColumnFull = (col) => {
    return getLowestAvailableRow(board, col) === null;
  };

  // Render column drop zones (invisible buttons above each column)
  const renderColumnButtons = () => {
    return (
      <div className="column-buttons">
        {Array.from({ length: COLS }).map((_, col) => {
          const isFull = isColumnFull(col);
          return (
            <motion.button
              key={col}
              className={`column-button ${isFull ? 'full' : ''}`}
              onClick={() => !disabled && !isFull && onColumnClick(col)}
              disabled={disabled || isFull}
              whileHover={!disabled && !isFull ? { scale: 1.1 } : {}}
              whileTap={!disabled && !isFull ? { scale: 0.9 } : {}}
            >
              {!disabled && !isFull && <span className="drop-indicator">▼</span>}
            </motion.button>
          );
        })}
      </div>
    );
  };

  // Render the board grid
  const renderBoard = () => {
    const cells = [];

    for (let row = 0; row < ROWS; row++) {
      for (let col = 0; col < COLS; col++) {
        const index = row * COLS + col;
        const cell = board[index];
        const isEmpty = !cell || cell === '' || cell === null;

        cells.push(
          <motion.div
            key={index}
            className={`connect4-cell ${!isEmpty ? `filled-${cell}` : ''} ${
              isWinningCell(index) ? 'winning' : ''
            }`}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: (row * COLS + col) * 0.02 }}
          >
            {!isEmpty && (
              <motion.div
                className={`disc disc-${cell}`}
                initial={{ y: -600, scale: 0.8 }}
                animate={{ y: 0, scale: 1 }}
                transition={{
                  type: 'spring',
                  stiffness: 150,
                  damping: 12,
                  delay: 0.1,
                }}
              />
            )}
          </motion.div>
        );
      }
    }

    return cells;
  };

  return (
    <div className="connect4-board-container">
      {renderColumnButtons()}
      <div className="connect4-board">
        {renderBoard()}
      </div>
    </div>
  );
};

export default Connect4Board;
